import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { MaterialService } from './material.service';
import { ModeFinancement, ModeFinancementList } from '../model/mode-financement.model';
import { Paginator } from '../model/paginator.model';

@Injectable()
export class ModeFinancementService extends KiwixiService {
  private readonly API_URL = `${environment.server}mode_financements/`;

  constructor(
    private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,
  ) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  /**
   * Récupère la liste des modes de financement avec filtres optionnels
   */
  get(params?: HttpParams): Observable<ModeFinancementList> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.get<ModeFinancementList>(this.API_URL, { headers, params }).pipe(
      catchError(this.handleErrorObservable<ModeFinancementList>('getModeFinancements'))
    );
  }

  getOne(id: number): Observable<ModeFinancement> {
    const headers = this.createHttpClientAuthorizationHeader();
    return this._http.get<ModeFinancement>(`${this.API_URL}${id}/`, { headers }).pipe(
      catchError(this.handleErrorObservable<ModeFinancement>('getModeFinancement'))
    );
  }
}
